import { planResourcesService } from '@/services/plan-resources';
import type { PlanResource } from '@/services/plan-resources/types';
import { useQuery } from '@tanstack/react-query';

export function useBusinessAssistances(productId: string | undefined) {
  return useQuery({
    queryKey: ['business', 'product-assistances', productId],
    enabled: Boolean(productId),
    queryFn: async (): Promise<PlanResource[]> => {
      const result = await planResourcesService.listByProduct(productId!);
      if (!result.success || !result.data) {
        throw new Error(result.error || 'Falha ao buscar assistências');
      }
      return result.data;
    },
  });
}
